import { AlertCircle, Megaphone } from 'lucide-react';
import styled from 'styled-components';

import { TipoAviso } from '../../../../types/aviso';

interface Props {
  tipo: TipoAviso;
  titulo: string;
  mensagem: string;
}

const GeralBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  background: ${({ theme }) => theme.colors.brandGradient ?? theme.colors.brandPrimary};
  color: #fff;
  font-size: 13px;
  border-radius: ${({ theme }) => theme.radius.sm};

  strong {
    font-weight: 700;
  }
`;

const FinanceiroCard = styled.div`
  display: flex;
  gap: 10px;
  padding: 12px 14px;
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.colors.dangerBg};
  border-left: 3px solid ${({ theme }) => theme.colors.warning};

  svg {
    color: ${({ theme }) => theme.colors.warning};
    flex-shrink: 0;
    margin-top: 2px;
  }

  div {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  strong {
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.textPrimary};
  }

  span {
    font-size: 13px;
    color: ${({ theme }) => theme.colors.textSecondary};
    line-height: 1.4;
    white-space: pre-wrap;
  }
`;

export const AvisoBannerPreview = ({ tipo, titulo, mensagem }: Props) => {
  if (tipo === TipoAviso.GERAL) {
    return (
      <GeralBanner data-testid="aviso-preview-geral">
        <Megaphone size={14} aria-hidden />
        <span>
          {titulo ? <strong>{titulo}</strong> : null}
          {titulo && mensagem ? ' · ' : null}
          {mensagem}
        </span>
      </GeralBanner>
    );
  }

  return (
    <FinanceiroCard data-testid="aviso-preview-financeiro">
      <AlertCircle size={16} aria-hidden />
      <div>
        {titulo && <strong>{titulo}</strong>}
        <span>{mensagem}</span>
      </div>
    </FinanceiroCard>
  );
};
